{
  "navigation": {
    "modules": {
      "home": "الرئيسية",
      "buying": "الشراء",
      "decisions": "القرارات",
      "procurement": "المشتريات",
      "suppliers": "الموردون",
      "administration": "الإدارة",
      "masterData": "البيانات الأساسية",
      "reports": "التقارير"
    },
    "workAreas": "مجالات العمل",
    "allWorkAreas": "جميع مجالات العمل",
    "moduleNavigation": "التنقل في {{module}}",
    "openModule": "تصفح {{module}}",
    "reportLoading": "جارٍ تحميل التقارير المتاحة…",
    "reportError": "تعذر تحميل التقارير المتاحة.",
    "cartLines": "{{count}} بند في السلة"
  }
}
